// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-wrapper[data-v-1e056e34] .card {\n  display: flex !important;\n  margin-bottom: 0;\n}\n.bg-color[data-v-1e056e34] {\n  background-color: white !important;\n}\n@media (min-width: 768px) {\n.courses-list[data-v-1e056e34] {\n    -webkit-column-count: 3;\n       -moz-column-count: 3;\n            column-count: 3;\n}\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
